import { State } from './State'

export function States({ states }) {

    return(
        states.map((state, index) => (
            <State 
                key={index}
                state={state}
            />
        ))
    )
}
